import React from "react";
import axios from "axios";
import Pagination from "../../Pagination/Pagination";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import { useAppContext } from "../../Lib/ContextLib";
import html2pdf from "html2pdf.js";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EmptyState from "../../Components/EmptyState";

export default function History() {
  const { accessObject } = useAppContext();
  const [dataRows, setdataRows] = React.useState([]);
  const [searchPhoneNo, setSearchPhoneNo] = React.useState("");
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [loader, setLoader] = React.useState(false);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  const [pageNumber, setPageNumber] = React.useState(1);
  const [recordLength, setRecordLength] = React.useState(10);
  const [totalLength, setTotalLength] = React.useState(0);
  const [selectedRecord, setSelectedRecord] = React.useState(null);
  const [viewMode, setViewMode] = React.useState(false);

  React.useEffect(() => {
    getBranch();
  }, [searchPhoneNo, pageNumber, recordLength]);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const getBranch = () => {
    setLoader(true);

    axios
      .post(`${API_URL}/api/admin/history/get-history-data`, {
        pageNumber: pageNumber,
        recordLength: recordLength,
        search: searchPhoneNo,
      })
      .then((response) => {
        setLoader(false);
        if (response?.data?.data?.totalLength > 0) {
          setdataRows(response.data.data.getHistoryData);
          setTotalLength(response?.data?.data?.totalLength);
        } else {
          setdataRows([]);
          setTotalLength(0);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleViewRecord = (record) => {
    setSelectedRecord(record);
    setViewMode(true);
  };

  const handleBackToList = () => {
    setViewMode(false);
    setSelectedRecord(null);
  };

  if (viewMode && selectedRecord) {
    const gameNames = ["-","Smash Block","Tic Tac Toe","Block Blast","Word Book","Number Puzzle 2248","Logic Line","Candy Cream","8 ball Pool","Chess Gamebit","Ludo Lion","Poker Pro","Classy Carrom","Teenpatti"];
    const noteNames = ["Win","Bet","Add Cash","Withdraw","Reward","Refund","Test"];
    const statusMap = { 0: { label: "Pending", color: "#f5a623" }, 1: { label: "Success", color: "#28a745" }, 2: { label: "Failed", color: "#dc3545" } };
    const txTypeMap = { 0: { label: "Debit", color: "#dc3545" }, 1: { label: "Credit", color: "#28a745" } };
    const currentStatus = statusMap[selectedRecord.status] || { label: "-", color: "#6c757d" };
    const currentTxType = txTypeMap[selectedRecord.transactionType] || { label: "-", color: "#6c757d" };

    const InfoCard = ({ label, value, badge, badgeColor }) => (
      <div style={{ background: "#f8f9fa", borderRadius: "10px", padding: "14px 18px", marginBottom: "14px", borderLeft: "4px solid #f5a623" }}>
        <div style={{ fontSize: "11px", fontWeight: "600", color: "#999", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "5px" }}>{label}</div>
        {badge ? (
          <span style={{ background: badgeColor, color: "#fff", padding: "3px 12px", borderRadius: "20px", fontSize: "13px", fontWeight: "600" }}>{value}</span>
        ) : (
          <div style={{ fontSize: "15px", fontWeight: "600", color: "#2d3748" }}>{value || "-"}</div>
        )}
      </div>
    );

    return (
      <div className="content p-3">
        <div className="card" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 20px rgba(0,0,0,0.08)" }}>
          {/* Header */}
          <div className="card-header bg-white" style={{ borderRadius: "12px 12px 0 0", borderBottom: "1px solid #f0f0f0", padding: "18px 24px" }}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div style={{ width: "40px", height: "40px", background: "#f5a623", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "14px" }}>
                  <i className="fas fa-receipt" style={{ color: "#fff", fontSize: "18px" }}></i>
                </div>
                <div>
                  <h5 style={{ margin: 0, fontWeight: "700", color: "#2d3748" }}>Transaction Details</h5>
                  <small style={{ color: "#999" }}>ID: {selectedRecord.historyId}</small>
                </div>
              </div>
              <button className="btn btn-outline-secondary btn-sm" style={{ borderRadius: "8px", fontWeight: "600" }} onClick={handleBackToList}>
                ← Back to List
              </button>
            </div>
          </div>

          <div className="card-body" style={{ padding: "24px" }}>
          {/* Amount Highlight */}
            <div style={{ background: "linear-gradient(135deg, #1a202c, #2d3748)", borderRadius: "14px", padding: "24px 28px", marginBottom: "24px" }}>
              <div style={{ color: "rgba(255,255,255,0.5)", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "1.5px", marginBottom: "8px" }}>Transaction Amount</div>
              <div style={{ color: "#ffffff", fontSize: "38px", fontWeight: "800", marginBottom: "20px", lineHeight: 1 }}>
                ₹ {Math.round(selectedRecord.amount * 100) / 100}
              </div>
              <div style={{ display: "flex", gap: "32px" }}>
                <div>
                  <div style={{ color: "rgba(255,255,255,0.45)", fontSize: "10px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "4px" }}>Type</div>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                    <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: currentTxType.color, flexShrink: 0 }}></div>
                    <span style={{ color: "#fff", fontSize: "14px", fontWeight: "700" }}>{currentTxType.label}</span>
                  </div>
                </div>
                <div style={{ width: "1px", background: "rgba(255,255,255,0.1)" }}></div>
                <div>
                  <div style={{ color: "rgba(255,255,255,0.45)", fontSize: "10px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "4px" }}>Status</div>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                    <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: currentStatus.color, flexShrink: 0 }}></div>
                    <span style={{ color: "#fff", fontSize: "14px", fontWeight: "700" }}>{currentStatus.label}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Info Grid */}
            <div className="row">
              <div className="col-md-6">
                <InfoCard label="Player ID" value={selectedRecord.playerId} />
                <InfoCard label="Date" value={moment(selectedRecord.createdAt).format("DD MMM YYYY, hh:mm A")} />
                <InfoCard label="Game" value={gameNames[selectedRecord.gameNo] || "-"} />
                <InfoCard label="Note" value={noteNames[selectedRecord.note] || "-"} />
              </div>
              <div className="col-md-6">
                {selectedRecord.paymentUserName && <InfoCard label="Payment User Name" value={selectedRecord.paymentUserName} />}
                {selectedRecord.paymentContact && <InfoCard label="Payment Contact" value={selectedRecord.paymentContact} />}
                {selectedRecord.bankAccountNo && <InfoCard label="Bank Account No" value={selectedRecord.bankAccountNo} />}
                {selectedRecord.bankUniqueNo && <InfoCard label="Bank Unique No" value={selectedRecord.bankUniqueNo} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="content p-3">
        <div className="card ">
          <div className="card-header bg-white border-bottom-0 pb-0 pt-4 px-4">
            <div className="row align-items-center">
              <div className="col-md-6 mb-3 mb-md-0">
                <div className="position-relative">
                  <i className="fas fa-search text-muted position-absolute" style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, fontSize: '0.9rem' }}></i>
                  <input
                    className="premium-search-input"
                    type="text"
                    placeholder="Search Playerid..."
                    value={searchPhoneNo}
                    onChange={(e) => {
                      setPageNumber(1);
                      setRecordLength(10);
                      setSearchPhoneNo(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6 text-right">
                {accessObject?.historyDownload == true && (
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      const input = document.getElementById("download-PDF");
                      const opt = {
                        filename: "History-List.pdf",
                      };
                      html2pdf().set(opt).from(input).save().from().toPdf();
                    }}
                  >
                    Download PDF
                  </button>
                )}
              </div>
            </div>
          </div>
          <div
            className="card-body"
            id="download-PDF"
            style={{ overflow: "scroll" }}
          >
            <table
              className="table table-bordered table-striped"
              id="table-to-xls"
            >
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>Id</th>
                  <th style={{ textAlign: "center" }}>Date</th>
                  <th style={{ textAlign: "center" }}>Player Id</th>
                  <th style={{ textAlign: "center" }}>Game</th>
                  <th style={{ textAlign: "center" }}>Transaction Type</th>
                  <th style={{ textAlign: "center" }}>Amount</th>
                  <th style={{ textAlign: "center" }}>Status</th>
                  <th style={{ textAlign: "center" }}>Action</th>
                </tr>
              </thead>

              {accessObject?.getHistoryList == true ? (
                <>
                  <tbody>
                    {!loader ? (
                      <>
                        {dataRows?.length > 0 ? (
                          <>
                            {dataRows?.map((item, index) => (
                              <tr key={index} style={{ textAlign: "center" }}>
                                <td style={{ textAlign: "center" }}>
                                  {pageNumber === 1
                                    ? index + 1
                                    : index +
                                      1 +
                                      pageNumber * recordLength -
                                      recordLength}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {moment(item.createdAt).format("DD-MM-YYYY")}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.playerId ? item.playerId : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.gameNo === 0
                                    ? "-"
                                    : item.gameNo === 1
                                    ? "Smash Block"
                                    : item.gameNo === 2
                                    ? "Tic Tac Toe"
                                    : item.gameNo === 3
                                    ? "Block Blast"
                                    : item.gameNo === 4
                                    ? "Word Book"
                                    : item.gameNo === 5
                                    ? "Number Puzzle 2248"
                                    : item.gameNo === 6
                                    ? "Logic Line"
                                    : item.gameNo === 7
                                    ? "Candy Cream"
                                    : item.gameNo === 8
                                    ? "8 ball Pool"
                                    : item.gameNo === 9
                                    ? "Chess Gamebit"
                                    : item.gameNo === 10
                                    ? "Ludo Lion"
                                    : item.gameNo === 11
                                    ? "Poker Pro"
                                    : item.gameNo === 12
                                    ? "Classy Carrom"
                                    : item.gameNo === 13
                                    ? "teenpatti"
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.transactionType === 0
                                    ? "Debit"
                                    : item.transactionType === 1
                                    ? "Credit"
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {Math.round(item.amount * 100) / 100}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.status === 0
                                    ? "Pending"
                                    : item.status === 1
                                    ? "Success"
                                    : item.status === 2
                                    ? "Failed"
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  <div className="d-flex justify-content-center">
                                    <VisibilityIcon
                                      className="courser"
                                      style={{ color: '#000', cursor: 'pointer', fontSize: '20px' }}
                                      onClick={() => handleViewRecord(item)}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <EmptyState colSpan={8} />
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </tbody>
                </>
              ) : (
                <>
                  <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                    <td colSpan={8}>
                      <h5 className="text-center">Access Denied</h5>
                    </td>
                  </tr>
                </>
              )}
            </table>
            {accessObject?.getHistoryList == true && (
              <div className="mt-4">{loader && <Loader />}</div>
            )}
          </div>
          {accessObject?.getHistoryList == true && dataRows.length != 0 && (
            <Pagination
              updateShowPerpagevalue={updateShowPerpagevalue}
              showPrePage={showPrePage}
              onPaginationChange={onPaginationChange}
              total={dataRows.length}
              paginationTypeApi={true}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              recordLength={recordLength}
              setRecordLength={setRecordLength}
              totalLength={totalLength}
            />
          )}
        </div>
      </div>
    </div>
  );
}
